import { render, staticRenderFns } from "./TemplateMessageEmpty.vue?vue&type=template&id=581ad3ac"
import script from "./TemplateMessageEmpty.vue?vue&type=script&lang=js"
export * from "./TemplateMessageEmpty.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageEmpty.vue?vue&type=style&index=0&id=581ad3ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports